import { colorPalette } from "../../utils/constants";

export const customStyles = {
  ctaSection: {
    backgroundColor: "#f5f5f5",
    padding: "32px",
    borderRadius: "8px",
    textAlign: "center" as const,
    marginTop: "48px",
  },
  ctaTitle: {
    color: colorPalette.sectionTitle,
    fontFamily: "'Bebas Neue', sans-serif",
    marginBottom: "16px",
  },
  ctaText: {
    marginBottom: "24px",
    fontSize: "16px",
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 400,
  },
  buttonGroup: {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    flexWrap: "wrap" as const,
  },
  callButton: {
    backgroundColor: colorPalette.sectionTitle,
    color: colorPalette.white,
    padding: "12px 32px",
    fontSize: "16px",
    fontWeight: "bold",
    textTransform: "none" as const,
    "&:hover": {
      backgroundColor: colorPalette.headerBackground,
    },
  },
  backButton: {
    borderColor: colorPalette.sectionTitle,
    color: colorPalette.sectionTitle,
    padding: "12px 32px",
    fontSize: "16px",
    fontWeight: "bold",
    textTransform: "none" as const,
    "&:hover": {
      borderColor: colorPalette.headerBackground,
      color: colorPalette.headerBackground,
      backgroundColor: "rgba(23, 84, 96, 0.05)",
    },
  },
};
